import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetUtranCellsLastUpdateRequest,
	GetUtranSitesRequest,
	RunCpichValidationRequest,
	GetCpichValidationExportRequest,
	GetCpichValidationTableRequest
} from '../requests/CpichValidationRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_UTRANCELLS_LAST_UPDATE = 'GET_UTRANCELLS_LAST_UPDATE';
export const GET_UTRAN_SITES = 'GET_UTRAN_SITES';
export const GET_CPICH_VALIDATION_TABLE = 'GET_CPICH_VALIDATION_TABLE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

const onGetUtranCellsLastUpdate = (value) => ({
	type: GET_UTRANCELLS_LAST_UPDATE,
	utranCellsLastUpdate: value
});

export const GetUtranCellsLastUpdate = () => async (dispatch) => {
	await GetUtranCellsLastUpdateRequest().then(response => {
		dispatch(onGetUtranCellsLastUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetUtranSites = (value) => ({
	type: GET_UTRAN_SITES,
	utranSites: value
});

export const GetUtranSites = () => async (dispatch) => {
	await GetUtranSitesRequest().then(response => {
		dispatch(onGetUtranSites(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetCpichValidationTable = (value) => ({
	type: GET_CPICH_VALIDATION_TABLE,
	cpichValidationTableData: value
});

export const GetCpichValidationTable = () => async (dispatch) => {
	await GetCpichValidationTableRequest().then(response => {
		dispatch(onGetCpichValidationTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunCpichValidation = (sites, userId) => async (dispatch) => {
	await RunCpichValidationRequest(sites, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetCpichValidationExport = (cpichValidationId) => async (dispatch) => {
	await GetCpichValidationExportRequest(cpichValidationId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
